export default __webpack_public_path__ + "static/media/UDI.69619626.svg";